import { ChartType } from "@/models/ChartType";
import { ChartOptions, ChartTooltipModel } from "chart.js";

export default {

  generateCustomTooltipsFunction(chartEl: Element): ((tooltipModel: ChartTooltipModel) => void ) | undefined {
    return (tooltipModel: ChartTooltipModel) => {
      let tooltipEl = document.getElementById("chartjs-tooltip");
      if (!tooltipEl) {
        tooltipEl = document.createElement("div");
        tooltipEl.id = "chartjs-tooltip";
        tooltipEl.innerHTML = "<div class='tooltip-wrapper'></div>";
        document.body.appendChild(tooltipEl);
      }
      tooltipEl.style.opacity = tooltipModel.opacity.toString();
      tooltipEl.classList.remove("above", "below", "no-transform"); // set caret position
      if (tooltipModel.yAlign) {
        tooltipEl.classList.add(tooltipModel.yAlign);
      } else {
        tooltipEl.classList.add("no-transform");
      }
      
      function getBody(bodyItem: any) {
        return bodyItem.lines;
      }

      if (tooltipModel.body) {
        const titleLines = tooltipModel.title || [];
        const bodyLines = tooltipModel.body.map(getBody);
        let innerHtml = "";
        if (titleLines.length > 0) {
          innerHtml += "<div>";
          titleLines.forEach(function(title: any) {
            innerHtml += `<div>${title}</div>`;
          });
          innerHtml += "</div>";
        }
        bodyLines.forEach(function(body: any, i: any) {
          const colors = tooltipModel.labelColors[i];
          const span = `<div class="chartjs-tooltip-color" style="background: ${colors.backgroundColor}"></div>`;
          innerHtml += `<div style="display: flex; align-items: center;">${span}<div>${body}</div></div>`;
        });
        let tableRoot = tooltipEl.querySelector(".tooltip-wrapper");
        if (tableRoot) {
          tableRoot.innerHTML = innerHtml;
        }
      }
      if (chartEl) {
        const position = chartEl.getBoundingClientRect();
        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.x + "px";
        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.y + "px";
      }
    }
  },

  generatePieChartOptions(chartEl: Vue, chartType: ChartType,
        applyGraphClickFilters: (chartType: ChartType, label: string, id?: string | undefined) => void,
        applyGraphClickFiltersCheckCanHover: (chartType: ChartType, label: string, id?: string | undefined) => boolean
  ): ChartOptions | undefined {
    if (!chartEl) {
      return undefined;
    }
    return {
      legend: {
        display: false,
      },
      layout: {
        padding: 10,
      },
      aspectRatio: 1,
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0,
      },
      hover: {
        animationDuration: 200,
        onHover: function(e: MouseEvent) {
          if (e.target) {
            let cursorStyle = "default";
            const target = e.target as HTMLCanvasElement;
            const points = this.getElementAtEvent(e);
            if (points.length) {
              const activeElement = points[0] as ChartElement;
              if (activeElement._chart.config.data?.labels) {
                const label = activeElement._chart.config.data.labels[activeElement._index];
                let id: string | undefined;
                if (activeElement._chart.config.data.datasets && activeElement._chart.config.data.datasets.length > 1) {
                  id = (activeElement._chart.config.data.datasets[1].backgroundColor as string[])[activeElement._index];
                }
                if (applyGraphClickFiltersCheckCanHover(chartType, label as string, id)) {
                  cursorStyle = "pointer";
                }
              }
            }
            target.style.cursor = cursorStyle;
          }
       }
      },
      responsiveAnimationDuration: 0,
      plugins: {
        datalabels: {
          align: "start",
          anchor: "end",
          color: "#fff",
          offset: 3,
          padding: 0,
          textAlign: "center",
          font: {
            weight: 600,
            size: 13,
            family: "Assistant",
          },
        },
      },
      elements: {
        arc: {
          borderWidth: 1,
        },
      },
      tooltips: {
        enabled: false,
        custom: this.generateCustomTooltipsFunction(chartEl.$el)
      },
      onClick: (e: MouseEvent, activeElements: ChartElement[]) => {
        if (activeElements.length > 0) {
          const activeElement: ChartElement = activeElements[0];
          if (activeElement._chart.config.data?.labels) {
            const label = activeElement._chart.config.data.labels[activeElement._index];
            let id: string | undefined;
            if (activeElement._chart.config.data.datasets && activeElement._chart.config.data.datasets.length > 1) {
              id = (activeElement._chart.config.data.datasets[1].backgroundColor as string[])[activeElement._index];
            }
            applyGraphClickFilters(chartType, label as string, id);
          }
        }
      }
    }
  }
};

interface ChartElement {
  hidden: boolean;
  _chart: Chart;
  _datasetIndex: number;
  _index: number;
}